import React, { useState, useEffect } from 'react';
import {
    Card,
    CardFooter,
    Pagination,
    PaginationItem,
    PaginationLink,
    Table,
    Container,
    Row
} from 'reactstrap';
import RowData from './RowData';
import TablePagination from 'commonComponents/TablePagination';

//component for Table details with header
const TableRoot = ({
    header,
    tableData,
    handleEdit,
    handleDelete,
    handleView,
    currentPage,
    totalPages,
    handlePageChange,
    rowsPerPage,
    setRowsPerPage
}) => {
    const getPageNumbers = () => {
        const pages = [];
        if (totalPages <= 2) {
            // If total pages are 2 or less, show all pages
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            // Show current page with one previous and one next page if possible
            if (currentPage === 1) {
                pages.push(currentPage, currentPage + 1);
            } else if (currentPage === totalPages) {
                pages.push(currentPage - 1, currentPage);
            } else {
                pages.push(currentPage - 1, currentPage, currentPage + 1);
            }
        }
        return pages;
    };

    const pageNumbers = getPageNumbers();
    return (
        <>
            <Container fluid>
                <Row>
                    <div className="col">
                        <Card className="shadow">
                            <Table className="align-items-center table-flush" responsive>
                                <thead className="thead-light">
                                    <tr>
                                        {
                                            header.map((item, index) => (
                                                <th scope="col" key={index} className="align-items-center text-center" >{item}</th>
                                            ))
                                        }
                                    </tr>
                                </thead>
                                {tableData.map((item, index) => (
                                    <RowData key={index} itemInfo={item} handleEdit={handleEdit} handleDelete={handleDelete} handleView={handleView} currentPage={currentPage} rowsPerPage={rowsPerPage} />
                                ))}
                            </Table>

                            <CardFooter className="py-4">
                                <TablePagination
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    handlePageChange={handlePageChange}
                                    rowsPerPage={rowsPerPage}
                                    setRowsPerPage={setRowsPerPage}
                                />

                            </CardFooter>
                        </Card>
                    </div>
                </Row>
            </Container>
        </>
    );
};

export default TableRoot;
